export const PROJECT_NAME_TEXT_FIELD = 'project-name-text-field';
export const JIRA_MIN_PROJECT_NAME_LENGTH = 2;
export const JIRA_MAX_PROJECT_NAME_LENGTH = 80;
